import { useEffect, useState } from 'react';
import Typist from 'react-typist-component';

export const Typewriter = ({
  textValues,
  loopDelay = 3000,
  typingDelay = 40,
}: {
  textValues: Array<string>;
  loopDelay?: number;
  typingDelay?: number;
}) => {
  const [text, setText] = useState(textValues[0]);
  const [loopNum, setLoopNum] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      const newLoop = loopNum + 1;
      if (loopNum < textValues?.length) {
        if (textValues[newLoop] !== text) {
          const newValue = textValues[newLoop] || textValues.slice(-1);
          setText(newValue.toString());
          setLoopNum(newLoop);
        }
      }
    }, loopDelay);
    return () => {
      clearTimeout(timer);
    };
  }, [loopNum, textValues, loopDelay, text]);

  return (
    <Typist typingDelay={typingDelay} restartKey={loopNum}>
      {text}
    </Typist>
  );
};
